<p-toast position="top-right" key="msj"></p-toast>
<!--<p-messages></p-messages>-->
<p-confirmDialog [style]="{width: '50vw'}" key="confirmYN"
  [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
  rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar"
  [rejectVisible]="false"></p-confirmDialog>
<div class="d-flex justify-content-center">
  <div class="container-fluid" style="width: 95%;">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-shadow sinborde">
          <div class="card-header d-flex justify-content-arround align-items-center" style="background-color: #fff; border: none;">
            <div class="col-md-2 d-flex justify-content-between" style="background: none;">
              <div class="cardicono rounded">
                <i class="pi pi-users align-items-center mt-3" style="font-size: 2rem; color: #fff;"></i>
              </div>
            </div>
            <div class="col-md">
              <header style="width: 40vw;">Monitoreo de Colaboradores</header>
            </div>
            <!-- <div class="col-md-4">
              <header style="left: 11%; top: 5%;width: 50vw;">Monitoreo de Colaboradores</header>
            </div> -->
            <div>
              <p-button (click)="abrirModalReportes()" label="Reportes" 
                styleClass="p-button-raised p-button-success"
                icon="pi pi-file-excel" iconPos="left">
              </p-button>
            </div>
          </div>
          <div class="card-content">
            <div class="row mt-3">
              <p-table #dt1 [value]="lstChofer" [tableStyle]="{'min-width': '50rem'}"
                styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="480px"
                responsiveLayout="scroll"
                [globalFilterFields]="['cod_chofer','nombres','apellido_Paterno','apellido_Materno','dsc_ciudad','rfc']"
                [paginator]="true" [rows]="50" [rowsPerPageOptions]="[20,45,50,100,150]" [showCurrentPageReport]="true"
                [resizableColumns]="false" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
                [loading]="loading" sortField="nombres">
                <ng-template pTemplate="caption">
                  <div class="row flex justify-content-end">
                    <div class="col-md-3">
                      <p-columnFilter field="clv_monitoreo" matchMode="contains" [showMenu]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown [ngModel]="value" [options]="lstEstatus" optionLabel="nombre" optionValue="id"
                            (onChange)="filter($event.value)" placeholder="Filtrar por Estatus" [showClear]="true">
                          </p-dropdown>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                    <!-- <div class="col-md-3">
                      <p-columnFilter type="text" field="desc_puesto" placeholder="Puesto"
                        class="w-100 sinborde filtro"></p-columnFilter>
                    </div> -->
                    <div class="col-md-3">
                      <span class="p-input-icon-left p-ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" size="30" (input)="applyFilterGlobal($event, 'contains')"
                          placeholder="RFC,Codigo Chofer,Nombres,Apellidos,Ciudad" />
                      </span>
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width:30vw;" pSortableColumn="cod_chofer">#Codigo<p-sortIcon field="cod_Chofer"></p-sortIcon>
                    </th>
                    <th style="width:80vw;" pSortableColumn="nombre_completo" >Nombre(s)<p-sortIcon 
                      field="nombre_completo"></p-sortIcon></th>
                    <th>Puesto</th>
                    <th pSortableColumn="rfc">RFC<p-sortIcon field="rfc"></p-sortIcon></th>
                    <!-- <th>Apellido Paterno</th>
                    <th>Apellido Materno</th> -->
                    <!-- <th pSortableColumn="desc_tipo_transporte">Tipo de Transporte<p-sortIcon
                        field="desc_tipo_transporte"></p-sortIcon></th> -->
                    <th style="width: 180px;" pSortableColumn="desc_ciudad">Ciudad<p-sortIcon
                        field="desc_ciudad"></p-sortIcon></th>
                    <th style="width: 180px;" pSortableColumn="fec_ingreso">Fecha ingreso<p-sortIcon
                        field="fec_ingreso"></p-sortIcon></th>
                    <th style="width: 180px;" pSortableColumn="dsc_truck">Es truck?<p-sortIcon
                        field="dsc_truck"></p-sortIcon></th>
                    <th style="width: 180px;" pSortableColumn="dsc_monitoreo">Estatus<p-sortIcon
                        field="dsc_monitoreo"></p-sortIcon></th>
                    <th style="width: 180px;" pSortableColumn="fec_estatus">Último Cambio<p-sortIcon
                        field="fec_estatus"></p-sortIcon></th>
                    <th class="text-center" style="min-width: 200px;">Acciones</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data let-index>
                  <tr [ngClass]="{'row-accessories': data.clv_estatus_monitoreo===0}">
                    <td>
                      <p class="texto_resaltado" style="color: rgb(28, 99, 230);">
                        {{data.cod_chofer}}</p>
                    </td>
                    <td class="texto_resaltado">{{data.nombre_completo}}</td>
                    <td class="text-center texto_bk">{{data.dsc_puesto}}</td>
                    <td class="texto_resaltado">{{data.rfc}}</td>
                    <!-- <td
                      [ngClass]="{'texto-ligero': data.clave_tipoTransporte==1,'texto-pesado': data.clave_tipoTransporte==2}"
                      class="text-justify">{{data.desc_tipo_transporte}}</td> -->
                    <td class="texto_resaltado" style="width: 180px; color: rgb(28, 99, 230);">{{data.dsc_ciudad}}</td>
                    <td class="texto_resaltado" style="width: 180px; color:rgb(128, 21, 228);">{{data.fec_ingreso}}</td>
                    <td class="text-center texto_resaltado" style="width: 180px;">{{data.dsc_truck}}</td>
                    <td class="texto_resaltado" 
                    [ngStyle]="(data.clv_monitoreo === 1) ? {'color':'rgb(37, 158, 24)'} 
                    : {'color':'rgb(230, 109, 28)'}" style="width: 180px;">{{data.dsc_monitoreo}}</td>
                    <td class="text-center texto_bk" style="width: 180px;">{{data.fec_estatus}}</td>
                     <td style="min-width: 200px;">
                        <div class="d-flex justify-content-around">
                          <div class="col-2" *ngIf="data.clv_monitoreo==0" >
                           <button pButton
                            (click)="confChngEstatus(data);" pTooltip="Habilitar Colaborador OP"
                            iconPos="left" class="p-button-primary p-button-rounded btn-sm" icon="pi pi-check-circle" 
                            tooltipPosition="left" appendTo="body"
                            [disabled]="!data.clv_type"></button>
                          </div>
                          <div class="col-2" *ngIf="data.clv_monitoreo==1" >
                            <button pButton
                            (click)="confChngEstatus(data);" pTooltip="Inhabilitar Colaborador OP"
                            iconPos="left" class="p-button-warning p-button-rounded btn-sm" icon="pi pi-times" 
                            tooltipPosition="left" appendTo="body"
                            [disabled]="!data.clv_type"></button>
                          </div>
                          <div class="col-2">
                            <button pButton (click)="verHst(data);" pTooltip="Ver Informacion"
                            iconPos="left" class="p-button-rounded btn-sm" icon="pi pi-info-circle" tooltipPosition="left" appendTo="body"></button>
                          </div>
                        </div>
                      </td>
                  </tr>
                </ng-template>
                <!--<ng-template pTemplate="summary">
                                    <div class="flex align-items-center justify-content-between">
                                        Un total de {{lstRutas ? lstRutas.length : 0 }} Registros.
                                    </div>
                                </ng-template>-->
              </p-table>
            </div>
            <div class="row mt-3 d-flex justify-content-center">
              <div class="col-6">
                <div class="mt-3 mb-2">
                  <p-colorPicker [(ngModel)]="color_gris_deshabilitadas" [disabled]="true"></p-colorPicker>
                  <p class="text-left informativo" style="display: inline;">
                    Colaborador Inactivo</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspComentario"
        [style]="{width: '50vw','height':'550px'}" [transitionOptions]="'0ms'"
        (onHide)="cancelarVentanaModal()">
        <ng-template pTemplate="header">
            {{ texto_operacion }}
        </ng-template>
        <ng-template pTemplate="content">
            <div class="card-content">
            <form class="form_cliente" [formGroup]="messageForm" (ngSubmit)="guardartexto()">
                <div class="ml-1">
                    <div class="row d-flex justify-content-start mt-2">
                <div class="col-md-2">
                    <label class="title-lightEd">Colaborador: </label>
                </div>
                    <div class="col-md-10">
                        <input type="text" pInputText
                        formControlName="nombre_completo" autoWidth="false" 
                        [style]="{'width':'80%'}" [disabled]="true">
                    </div>
                </div>
                <div class="row mt-1 d-flex justify-content-start">
                    <div class="col-sm-6">
                    <span class="title-light">Conteste a detalle las preguntas
                        <i class="pi pi-cog" style="size: 2rem;"></i>
                    </span>
                    </div>
                </div>
                <div class="row mt-2 title-light">
                    <p><span style="font-weight: bold; ">¿Cual es el motivo del cambio?</span></p>
                </div>

                <div class=" col-md-12 mt-3 justify-content-center text-center align-items-center">
                    <textarea formControlName="dsc_detalle" class="form-control" rows="5"
                    placeholder="Escribe motivo..." [style]="{'width':'80%', 'margin-top': '20px'}"
                    pTooltip="Motivo de inhabilitado" tooltipPosition="top"></textarea>
                </div>
                <!-- Información de la última modificación -->
                <div class="row d-flex ">
                    <div class="col-md-5  mt-6 justify-content-start">
                    </div>
                    <div class="col-md-3 mt-7 justify-content-center">
                      <button class="btn btn-primary form-control" pTooltip="Almacenar información"
                          tooltipPosition="right" [disabled]="!this.messageForm.valid">
                          <span class="text-white">Guardar </span>
                          <i class="pi pi-save text-white" 
                            *ngIf="this.messageForm.valid||(!this.messageForm.valid&&!this.loading_texto)"></i>
                          <i class="pi pi-spin pi-spinner"
                           *ngIf="!this.messageForm.valid&&this.loading_texto"></i>                          
                      </button>
                    </div>
                </div>
                </div>
            </form>
            </div>
            
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
            (click)="cancelarVentanaModal()"></button>
        </ng-template>
    </p-dialog>
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspInfo" 
        [style]="{width: '70vw','height':'75vh'}"
        (onHide)="CancelInfo()" [transitionOptions]="'0ms'" styleClass="card-shadow">
        <ng-template pTemplate="header">
            Info Estatus Colaborador OP
        </ng-template>
        <ng-template pTemplate="content">    
            <div class="row d-flex justify-content-end align-items-center mt-2">
              <div class="col-md-2 texto-ligero" style="font-size:large;">
                  <label>Colaborador: </label>
              </div>
              <div class="col-md-10">
                  <input type="text" pInputText
                  value="{{colabInfo}}" autoWidth="false" 
                  [style]="{'width':'80%'}" [disabled]="true">
              </div>
            </div>
            <div class="row pb-2">
                <div class="row d-flex mt-3 ml-1">
                    <p-table [value]="lstHstEst" [responsive]="true" 
                    [style]="{'width':'100%'}" [loading]="loading_info">
                        <ng-template pTemplate="header">
                        <tr>
                            <th>Estatus</th>
                            <th style="width: 120px;">Descripción</th>
                            <th>Días Inhabil</th>
                            <th>Fecha Inicio</th>
                            <th>Fecha Fin</th>
                            <th>Usuario Inhabilito</th>
                            <th>Usuario Habilito</th>
                        </tr>
                        </ng-template>
                    
                        <ng-template pTemplate="body" let-item>
                        <tr>
                            <td class="text-center texto_resaltado texto_bk"
                             [ngStyle]="(item.clv_estatus === 1) ? {'color':'rgb(37, 158, 24)'} 
                             : {'color':'rgb(230, 132, 28)'}">{{ item.dsc_monitoreo }}</td>
                            <td class="texto_resaltado"style="font-size: 12px">{{ item.dsc_motivo }}</td>
                            <td class="text-center texto_bk">{{ item.num_dias }}</td>
                            <td class="text-center texto_resaltado" style="color:rgb(128, 21, 228)">{{ item.dsc_fec_inicio }}</td>
                            <td class="text-center texto_resaltado" style="color:rgb(128, 21, 228)">{{ item.dsc_fec_fin }}</td>
                            <td class="text-center texto_resaltado" style="color: rgb(230, 132, 28);">{{ item.usuario_inicio}}</td>
                            <td class="text-center texto_resaltado" style="color: rgb(28, 99, 230);">{{ item.usuario_fin}}</td>
                        </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" 
            (click)="CancelInfo();"></button>
        </ng-template>
    </p-dialog>
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dbsReportes" 
    [style]="{width: '95vw','height':'785px'}"
    [transitionOptions]="'0ms'" styleClass="card-shadow" (onHide)="cancelarModalReportes()">
    <ng-template pTemplate="header">
      Reportes
    </ng-template>
    <div class="reporteria-container  mt-5 " >
      <section class="reportes-area">
        <div class="card">
          <div class="reportes-grid">
            
            <div *ngFor="let reporte of reportes" class="reporte-card">
              <h5>
                <i class="pi pi-file-excel" style="font-size: 1.8rem; color: #217346;"></i>
                {{ reporte.titulo }}
              </h5>
              <p class="texto_sm">{{ reporte.descripcion }}</p>
              <form [formGroup]="reporte.frm">
                <div class="row mb-2">
                  <!-- Caso especial: Reporte 1 con mes y año -->
                  <ng-container *ngIf="reporte.typ_reporte === 1; else fechaNormal">
                    <div class="col-4">
                      <p-dropdown [options]="lstCiudades" optionLabel="nombre" formControlName="id_ciudad_hm"
                        placeholder="Ciudad*" [style]="{'width':'100%'}"></p-dropdown>
                      <!-- <p-dropdown [options]="lstCiudades" optionLabel="nombre" [(ngModel)]="reporte.ciudad"
                        placeholder="Ciudad*" [style]="{'width':'100%'}"></p-dropdown> -->
                    </div>
                    <div class="col-4">
                      <p-dropdown [options]="meses" optionLabel="nombre" formControlName="mes" placeholder="Mes*"
                        [style]="{'width':'100%'}"></p-dropdown>
                      <!-- <p-dropdown [options]="meses" optionLabel="nombre" [(ngModel)]="reporte.mes" placeholder="Mes*"
                        [style]="{'width':'100%'}"></p-dropdown> -->
                    </div>
                    <div class="col-4">
                      <p-calendar formControlName="anio" dateFormat="yy" placeholder="Año*"
                        [style]="{'width':'100%'}"></p-calendar>
                      <!-- <p-calendar [(ngModel)]="reporte.anio" view="year" dateFormat="yy" placeholder="Año*"
                      [style]="{'width':'100%'}"></p-calendar> -->
                    </div>
                  </ng-container>

                  <!-- Otros reportes con fecha inicio / fin -->
                  <ng-template #fechaNormal>
                    <div [ngClass]="!(reporte.typ_reporte === 2) ? 'col-6' : 'col-4'">
                      <input formControlName="fec_inicio" type="date" class="form-control sinborde"
                        placeholder="Fecha inicio" style="height: -webkit-fill-available;"/>
                      <!-- <input [(ngModel)]="reporte.fec_inicio" type="date" class="form-control sinborde"
                        placeholder="Fecha inicio" required/> -->
                    </div>

                    <div *ngIf="(reporte.typ_reporte !== 4 )"
                      [ngClass]="!(reporte.typ_reporte === 2 || reporte.typ_reporte === 1) ? 'col-6' : 'col-4'">
                      <!-- <input [(ngModel)]="reporte.fec_fin" type="date" class="form-control sinborde"
                        placeholder="Fecha fin" min="2023-01-01" required/> -->
                      <input formControlName="fec_fin" type="date" class="form-control sinborde"
                        placeholder="Fecha fin" style="height: -webkit-fill-available;"/>
                    </div>

                    <div *ngIf="(reporte.typ_reporte === 4 || reporte.typ_reporte === 2)"
                      [ngClass]="(reporte.typ_reporte === 4 ) ? 'col-6' : 'col-4'">
                      <!-- <p-dropdown [options]="lstCiudades" optionLabel="nombre" [(ngModel)]="reporte.ciudad"
                        placeholder="Ciudad*" [style]="{'width':'100%'}"></p-dropdown> -->
                      <p-dropdown formControlName="id_ciudad_hm" [options]="lstCiudades" optionLabel="nombre"
                        optionValue="id"
                        placeholder="Ciudad*" [style]="{'width':'100%'}"></p-dropdown>
                    </div>
                  </ng-template>

                </div>

                <div class="row">
                  <div class="col-6 mx-auto">
                    <button class="custom-button w-100" [disabled]="!reporte.frm.valid"
                      (click)="verReporte(reporte)">
                      Generar&nbsp;Reporte
                    </button>
                  </div>
                </div>
              </form> 
            </div>
          </div>
        </div>
      </section>
    </div>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelarModalReportes();"></button>
    </ng-template>
  </p-dialog>
</div>
